export default __webpack_public_path__ + "static/media/character-bear-happy.c60ccda1.png";